export default "__VITE_ASSET___Vk1sydQ__"